const classFilterToggled = 'filter--toggled';

$('.filter__toggle').on('click', function () {
    let $filter = $(this).closest('.filter'),
        $options = $(this).siblings('.filter__options');

    if ($filter.hasClass(classFilterToggled)) {
        $filter.removeClass(classFilterToggled);
        $options.stop().slideDown(150);
    } else {
        $options.stop().slideUp(150);
        $filter.addClass(classFilterToggled);
    }
});


$('.filter__show-collapsed').on('click', function () {
    let $toggle = $(this),
        $collapsed = $toggle.next('.filter__collapsed');

    $toggle.hide();
    $collapsed.show();
});


// collapse filters on pageload if small screen
if (viewport().width < 992) {
    $('.filters .filter').each(function () {
        let $filter = $(this),
            $options = $(this).find('.filter__options');

        $options.hide();
        $filter.addClass(classFilterToggled);
    });
}